"use client";

import { useEffect, useRef, useState } from "react";
import { loadFacebookSDK, facebookLogin } from "@/lib/facebook-sdk";

const FACEBOOK_APP_ID = process.env.NEXT_PUBLIC_FACEBOOK_APP_ID ?? "";

export function useFacebookLogin() {
  const [isReady, setIsReady] = useState(false);
  const initAttempted = useRef(false);

  useEffect(() => {
    if (!FACEBOOK_APP_ID || initAttempted.current) return;
    initAttempted.current = true;

    loadFacebookSDK(FACEBOOK_APP_ID)
      .then(() => setIsReady(true))
      .catch(() => {
        /* SDK failed to load — button will stay hidden */
      });
  }, []);

  async function login(): Promise<string> {
    return facebookLogin();
  }

  return { login, isReady };
}
